export default __webpack_public_path__ + "static/media/Alice 9781846168932.2708e73c.jpg";